module.exports = __webpack_public_path__ + "static/austin3-44e2dd228b1dc0fb9a69ba8902a26158.png";